<script setup>
import FsLightbox from "fslightbox-vue/v3";
import axios from 'axios';
import { onMounted, ref } from 'vue';
import { getYoutubeThumbnail } from '@/utils/useYoutube.js';

const toggler = ref(false);
const videos = ref([]);
const sources = ref([]);

async function getFeaturedVideos() {
    try {
        const res = await axios.get('/get-featured-videos-data');
        videos.value = res.data.map((video) => ({
            ...video,
            thumbnail: getYoutubeThumbnail(video.url),
        })) || [];
    } catch (error) {
        console.error('Error fetching:', error);
    }
}

const openLightbox = (videoUrl) => {
    sources.value = [videoUrl]; // Set the lightbox source
    toggler.value = !toggler.value; // Toggle the lightbox
};

onMounted(() => {
    getFeaturedVideos();
});
</script>

<template>
    <div class="xl:w-3/5 lg:w-1/2 w-full lg:mt-14 wow animate__animated animate__fadeInLeft">
        <el-carousel indicator-position="" arrow="hover" :interval="4000"
            class="xl:h-[310px] xl:w-[550px] lg:h-[300px] lg:w-[460px] md:h-[300px] md:w-[460px] h-[250px] w-full mx-auto border-[5px] rounded-3xl border-[#66B4DD] object-cover object-center overflow-hidden">
            <el-carousel-item v-for="video in videos" :key="video.id" @click="openLightbox(video.url)" class="relative cursor-pointer">
                <img :src="video.thumbnail" alt="Video Thumbnail" class="w-full h-full object-cover" />
                <div class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
                    <button class="bg-red-600 px-4 py-2 rounded-lg">
                        <i class="fa-brands fa-youtube text-3xl text-white"></i>
                    </button>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
    <FsLightbox :toggler="toggler" :sources="sources" />
</template>

<style scoped></style>
